import { RouteLocationNormalized } from 'vue-router'

import { useStoreRooms } from '@/app/store/pinia/rooms/rooms'

import { useStoreContacts } from '@/entities/contact'

import { useCurrentUser } from '@/shared/composables/current-user'
import { useLocalization } from '@/shared/composables/localization'
import { createPrivateRoom } from '@/shared/utils/im'

export const chatPropsFn = (route: RouteLocationNormalized): unknown => {
  const storeContacts = useStoreContacts()
  const storeRooms = useStoreRooms()
  const { currentUser } = useCurrentUser()
  const { t } = useLocalization()
  const id: string = atob(Array.isArray(route.params.id) ? route.params.id[0] ?? '' : route.params.id ?? '')
  const targetEventId: string = route.hash ? route.hash.split('#')[1] ?? '' : ''

  let room = storeRooms.rooms.get(id)

  if (!room) {
    const contact = storeContacts.findByPServed(id)
    if (contact) {
      room = createPrivateRoom(id, contact)
    }
  }

  const title = t('common.chat')
  const roomName = room
    ? room.pServedUser === currentUser.value?.imLogin
      ? t('common.savedMessages')
      : room.name
    : undefined
  if (roomName) {
    document.title = `${roomName} — ${title}`
  } else {
    document.title = title
  }

  return {
    id,
    room,
    targetEventId,
  }
}
